var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRebrandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 1056.28",
    style: {
      enableBackground: "new 0 0 4000 1056.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "184.2,368.41 679.89,368.41 679.89,871.78 890.62,871.78 890.62,368.41 1386.31,368.41 1386.31,184.2 184.2,184.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2382.77,184.21l-954.82,0v0h0l0,687.57h210.73V706.11h744.09c143.89,0,260.95-117.06,260.95-260.95 S2526.66,184.21,2382.77,184.21z M2375.28,521.91h-736.6v-153.5h736.6c42.32,0,76.75,34.43,76.75,76.75 S2417.6,521.91,2375.28,521.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3011.55,680.21c-83.93,0-152.22-68.28-152.22-152.22s68.28-152.22,152.22-152.22h804.25V183.91h-804.25 c-190.03,0-344.08,154.05-344.08,344.08s154.05,344.08,344.08,344.08h804.25V680.21H3011.55z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebrandLogo);
export default __webpack_public_path__ + "static/media/rebrand-logo.5fcada3d6c9737cd259c7a8f7dac5ecd.svg";
export { ForwardRef as ReactComponent };